<div class="row" *ngIf="pspes.modifiedPointStoreProduct != null">
	<div class="col-lg-12 fake-card mx-auto">
		<div class="row">
			<div class="pointStoreAssignmentContent ng-hide">
				<div class="pointStoreAssignmentArea">
					<div class="pointStoreAssignmentSelectAll">
						<div class="infieldReadOnlyHolder pointStoreAssignAllAssignments">
							<span class="infieldReadOnlyHeader" cvLocalizedText langSection="MarketPlace_Management"
								langKey="ASSIGN_ALL">ASSIGN ALL: </span>
							<span class="infieldReadOnlyValue"><input type="checkbox"
									[(ngModel)]="pspes.modifiedPointStoreProduct.AssignedGroups"
									(ngModelChange)="addRemoveAllAssignmentGroup()" /></span>
						</div>
					</div>
					<div class="clear"></div>

					<div class="pointStoreAssignmentGroupControl">
						<div class="pointStoreAssignmentControl">
							<!-- <uc:GroupList ID="GroupList1" cvLocalizedText GroupType="Employee" Height="275" HasLogins="false" HasProfiles="false" Source="{{groupListSource}}" GroupLevel="5" GroupID="0" /> -->
						</div>
						<div class="pointStoreAssignmentsAdded">
							<div class="assignmentTitle"><span cvLocalizedText langSection="MarketPlace_Management"
									langKey="Assigned_Groups">Assigned Groups</span> </div>
							<!-- <div class="pointStoreAssignmentSelected" *ngIf="(pspes.modifiedPointStoreProduct.PointStoreProductAssignments | filter : {isRemoved: false} : true).length != 0 "> -->
							<div class="pointStoreAssignmentSelected"
								*ngIf="(pspes.modifiedPointStoreProduct.PointStoreProductAssignments)">
								<!-- <div class="pointStoreLandingSummaryAssignmentList" data-ng-repeat="assignment in pspes.modifiedPointStoreProduct.PointStoreProductAssignments | filter : {isRemoved: false} : true"> -->
								<div class="pointStoreLandingSummaryAssignmentList"
									*ngFor="let assignment of pspes.modifiedPointStoreProduct.PointStoreProductAssignments">
									<div class="pointStoreLandingSummaryAssignmentContent"
										*ngIf="assignment.isRemoved == false">
										<div class="assignmentConent">
											<div class="assignmentSummary">
												<div class="topText"><strong>
														<span [hidden]="!(assignment.Name == 'All Groups Assigned')"
															cvLocalizedText langSection="MarketPlace_Management"
															langKey="All_Assigned_Groups">All Groups Assigned</span>
														<span
															[hidden]="!(assignment.Name != 'All Groups Assigned')">{{assignment.Name}}</span>
													</strong>{{assignment.GroupTypeName}}
												</div>
												<div class="bottomText">{{assignment.GroupSubNames}}</div>
											</div>
											<div class="assignmentButton">
												<div class='marginRight10 pointStoreImage remove-red-icon'
													(click)="removeAssignments(assignment)"
													title="{{getTitle('Remove Assignment')}}"></div>
											</div>
										</div>
										<div class="clearBoth"></div>
									</div>
								</div>
							</div>
						</div>
						<div class="clear"></div>
					</div>
				</div>
			</div>
		</div>
		<div class="row" style="min-height: calc(100vh - 300px);">
			<div class="col-10 offset-1 pt-2">
				<h2 cvLocalizedText langSection="MarketPlace_Management" langKey="Choose_Groups_Purchase" class="color-theUpsideDown font-size-18 lato-regular mt-4">Choose groups who can purchase this
					product</h2>
				<hr />
				<div class="fake-card assign-selector-container pb-2 col-9 my-5">
					<div class="row justify-content-center align-items-center pt-2">
						<div class="col-8"><span cvLocalizedText langSection="MarketPlace_Management" langKey="Assigned_To" class="font-size-16">Assigned to: </span></div>
						<div class="col-4 text-right">
							<div (click)="assignButtonClick();" role="button" tabindex="0">
								<svg class="icon-16 fill-valyrianSteel fill-hover-cerulean cursor-pointer">
									<use href="../../../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use>
								</svg>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<hr />
						</div>
					</div>
					<div class="row">
						<div class="col-12 " cv-custom-scrollbar="{ autoHideScrollbar: false }" data-mcs-theme="dark">
							<div cvLocalizedText langSection="Objectives" langKey="Employee_Groups" class="typeHeader lato-bold font-size-16 mt-1">Employee Group(s)</div>
							<div class="assignAtLabel" *ngIf="pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.empAssignAll"
								 cvLocalizedText langSection="Objectives" langKey="All_Groups">All Groups</div>

							<div class="assignAtLabel" [hidden]="!(pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.emp.length <= 0 && !pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.empAssignAll)">
								<span cvLocalizedText langSection="MarketPlace_Management_Messages" langKey="No_Groups_Assigned">No groups assigned</span>
							</div>

							<div *ngFor="let obj of pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.emp">
								<div class="FlexRowNoWrap itemContainer">
									<div class="objectiveItem txtOverflow">- {{obj.GroupName}}</div>
								</div>
							</div>

							<div class="my-4">
								<div class="typeHeader lato-bold font-size-16 mt-2">
									<span cvLocalizedText langSection="Objectives" langKey="Attributes">Attribute(s) </span><span cvLocalizedText langSection="MarketPlace_Management" langKey="Optional" class="color-valyrianSteel"> -Optional</span>
									<div class="fill-cerulean ml-2 d-inline">
										<svg class="icon-16"
											 [ngbPopover]="getLocalizationString('Attributes_Helper', 'If attributes are assigned, products will show up for all users, but only users who have them assigned will be able to purchase them.')"
											 triggers="mouseenter:mouseleave click" container="body"
											 [placement]="['right', 'auto']">
											<use href="../App_Themes/clearview-default/icons/utility/support.svg#support">
											</use>
										</svg>
									</div>
								</div>
								<div class="assignAtLabel"
									 [hidden]="!(pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.attr?.length == 0)"
									 cvLocalizedText langSection="Common" langKey="None">None</div>
								<div *ngFor="let obj of pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.attr">
									<div *ngIf="obj.AttributeValueID != null" class="FlexRowNoWrap itemContainer">
										<div class="objectiveItem txtOverflow">- {{obj.AttributeValueName}}</div>
										<div class="removeHolder FlexRowNoWrap">
											<div class="removeIcon FlexAlignVertical"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>


				<!-- <div class="createdCard" [ngClass]="{selectedCard: ctrlObjectivesAddEdit.of.addEdit.selectedObjective == $index}" (click)="ctrlObjectivesAddEdit.selectObjective($index)" *ngIf="ctrlObjectivesAddEdit.of.addEdit.assignedGroups.coreAssignAtType != null && ctrlObjectivesAddEdit.of.addEdit.assignedGroups.coreAssignAtLevel > 0 && card.AssignedLevel > 0 && ctrlObjectivesAddEdit.of.addEdit.assignedGroups.emp != null">
					<div class="FlexRowNoWrap">
						<div class="assignAtLabel txtOverflow" ng-show="card.AssignedLevel != 6">{{ctrlObjectivesAddEdit.of.addEdit.assignedGroups.coreAssignAtType == 'emp' ? ctrlObjectivesAddEdit.of.empGroupLabels[ctrlObjectivesAddEdit.of.empGroupLabels.length - card.AssignedLevel].GroupTypeName + '(s)' : ctrlObjectivesAddEdit.of.recGroupLabels[ctrlObjectivesAddEdit.of.recGroupLabels.length - card.AssignedLevel].GroupTypeName + '(s)'}}</div>
						<div class="assignAtLabel" ng-show="card.AssignedLevel == 6" cvLocalizedText langSection="Objectives" langKey="All_Groups">All Groups</div>
						<div (click)="ctrlObjectivesAddEdit.assignButtonClick();" *ngIf="$index == 0"><svg class="icon-16 fill-valyrianSteel-w-hover"><use href="../../../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use></svg></div>
						<button type="button" class="icon-btn fill-valyrianSteel-w-hover" (click)="ctrlObjectivesAddEdit.removeCard($index, $event);" *ngIf="$index > 0">
							<svg class="icon-16">
								<use href="../../../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use>
							</svg>
						</button>
					</div>
					<div class="groupSection" ng-show="ctrlObjectivesAddEdit.of.addEdit.assignedGroups.emp.length > 0">
						<div class="assignGroupLabel">{{ctrlObjectivesAddEdit.of.empGroupLabels[ctrlObjectivesAddEdit.of.empGroupLabels.length - ctrlObjectivesAddEdit.of.addEdit.assignedGroups.emp[0].GroupLevel].GroupTypeName}}</div>
						<div class="assignGroupValue txtOverflow">{{ctrlObjectivesAddEdit.of.addEdit.assignedGroups.emp[0].GroupName}}</div>
						<div class="assignGroupValue txtOverflow" ng-show="ctrlObjectivesAddEdit.of.addEdit.assignedGroups.emp.length == 2">{{ctrlObjectivesAddEdit.of.addEdit.assignedGroups.emp[1].GroupName}}</div>
						<div>
							<div class="assignGroupValueMore" ng-show="ctrlObjectivesAddEdit.of.addEdit.assignedGroups.emp.length > 2">{{'+ ' + (ctrlObjectivesAddEdit.of.addEdit.assignedGroups.emp.length - 1) }} 
								<span cvLocalizedText langSection="Objectives" langKey="More">More</span>
							</div>
							<md-tooltip class="objectiveTT" md-z-index="10001" md-direction="bottom" md-delay="500" style="margin: 0px;">
								<div class="FlexRowNoWrap" ng-repeat="item in ctrlObjectivesAddEdit.of.addEdit.assignedGroups.emp" *ngIf="$index > 0">
									<div>{{item.GroupName}}</div>
								</div>
							</md-tooltip>
						</div>
					</div>
					<div class="groupSection" ng-show="ctrlObjectivesAddEdit.of.addEdit.assignedGroups.rec.length > 0">
						<div class="assignGroupLabel">{{ctrlObjectivesAddEdit.of.recGroupLabels[ctrlObjectivesAddEdit.of.recGroupLabels.length - ctrlObjectivesAddEdit.of.addEdit.assignedGroups.rec[0].GroupLevel].GroupTypeName}}</div>
						<div class="assignGroupValue txtOverflow">{{ctrlObjectivesAddEdit.of.addEdit.assignedGroups.rec[0].GroupName}}</div>
						<div class="assignGroupValue txtOverflow" ng-show="ctrlObjectivesAddEdit.of.addEdit.assignedGroups.rec.length == 2">{{ctrlObjectivesAddEdit.of.addEdit.assignedGroups.rec[1].GroupName}}</div>
						<div>
							<div class="assignGroupValueMore" ng-show="ctrlObjectivesAddEdit.assignedGroups.rec.length > 2">{{'+ ' + (ctrlObjectivesAddEdit.of.addEdit.assignedGroups.rec.length - 1) }}
								<span cvLocalizedText langSection="Objectives" langKey="More">More</span>
							</div>
							<md-tooltip class="objectiveTT" md-z-index="10001" md-direction="bottom" md-delay="500" style="margin: 0px;">
								<div class="FlexRowNoWrap" ng-repeat="item in ctrlObjectivesAddEdit.of.addEdit.assignedGroups.rec" *ngIf="$index > 0">
									<div>{{item.GroupName}}</div>
								</div>
							</md-tooltip>
						</div>
					</div>
					<div class="groupSection" ng-show="ctrlObjectivesAddEdit.of.addEdit.assignedGroups.attr.length > 0">
						<div class="assignGroupLabel" cvLocalizedText langSection="Objectives" langKey="Attribute">Attribute</div>
						<div class="assignGroupValue txtOverflow">{{ctrlObjectivesAddEdit.of.addEdit.assignedGroups.attr[0].AttributeValueName}}</div>
						<div class="assignGroupValue txtOverflow" ng-show="ctrlObjectivesAddEdit.of.addEdit.assignedGroups.attr.length == 2">{{ctrlObjectivesAddEdit.of.addEdit.assignedGroups.attr[1].AttributeValueName}}</div>
						<div>
							<div class="assignGroupValueMore" ng-show="ctrlObjectivesAddEdit.of.addEdit.assignedGroups.attr.length > 2">{{'+ ' + (ctrlObjectivesAddEdit.of.addEdit.assignedGroups.attr.length - 1) }}
								<span cvLocalizedText langSection="Objectives" langKey="More">More</span>
							</div>
							<md-tooltip class="objectiveTT" md-z-index="10001" md-direction="bottom" md-delay="500" style="margin: 0px;">
								<div class="FlexRowNoWrap" ng-repeat="item in ctrlObjectivesAddEdit.of.addEdit.assignedGroups.attr" *ngIf="$index > 0">
									<div>{{item.AttributeValueName}}</div>
								</div>
							</md-tooltip>
						</div>
					</div>
				</div>
				<div class="quickAddCard FlexColNoWrap" (click)="ctrlObjectivesAddEdit.quickAddCard($index)" *ngIf="ctrlObjectivesAddEdit.of.addEdit.MetricObjectiveType == 0 && ctrlObjectivesAddEdit.of.addEdit.assignedGroups.coreAssignAtType != null && ctrlObjectivesAddEdit.of.addEdit.assignedGroups.coreAssignAtLevel > 0 && card.AssignedLevel == 0 && ctrlObjectivesAddEdit.of.addEdit.assignedGroups.emp != null">
					<svg class="icon-24 fill-cerulean assignAtIcon"><use href="../../../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
					<div class="assignAtLabel">
						<span cvLocalizedText langSection="Objectives" langKey="Create_Objective_For">Create objective for:</span>
						<span class="levelLabel">{{ ctrlObjectivesAddEdit.of.addEdit.assignedGroups.coreAssignAtType == 'emp' ? ctrlObjectivesAddEdit.of.empGroupLabels[ctrlObjectivesAddEdit.of.empGroupLabels.length - (ctrlObjectivesAddEdit.of.addEdit.editedObjectives.length - $index)].GroupTypeName : ctrlObjectivesAddEdit.of.recGroupLabels[ctrlObjectivesAddEdit.of.recGroupLabels.length - (ctrlObjectivesAddEdit.of.addEdit.editedObjectives.length - $index)].GroupTypeName}}</span>
					</div>
				</div> -->

				<!-- Permission Assigning Page -->
				<cv-angular-assign-tool [buttonText]="getLocalizationString('Assign','Assign')" type="marketplace" showTypes="emp agent_att"
					[showAll]="true" [singleAdd]="false" [singleType]="true" [showParent]="true"
					[headerText]="getLocalizationString('Assign_Groups', 'Assign Groups')"
					[(showPopup)]="showAssingTool"
					[(dataTransfer)]="pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments"
					(dataTransferChange)="onAssignmentsChanged($event)"></cv-angular-assign-tool>
			</div>
		</div>
		<div class="form-group row">
			<div class="col-12 d-flex justify-content-end">
				<button type="button" class="btn btn-text mr-2" (click)="cancel()">
					<span cvLocalizedText langSection="MarketPlace_Management" langKey="Cancel">Cancel</span>
				</button>
				<button type="button" class="btn btn-primary" (click)="next(5)">
					<span cvLocalizedText langSection="MarketPlace_Management" langKey="Next">Next</span>
				</button>
			</div>
		</div>
	</div>
</div>
